// @flow
import mediatorChannels from "@tvg/mediator";
import { get } from "lodash";
import pushToDataLayer from "../gtmUtils";

type PickBetsOnboardingGTMTypeEvents =
  | "PICK_BETS_ONBOARDING_SEEN"
  | "PICK_BETS_ONBOARDING_CLICK_INFO_BUBBLE"
  | "PICK_BETS_ONBOARDING_CLICK_CTA"
  | "PICK_BETS_ONBOARDING_CLOSE_MODAL";

type PickBetsOnboardingGTMType = {
  type: PickBetsOnboardingGTMTypeEvents,
  payload?: {
    onBoardingType?: string, // EX: 'pick bets'
    buttonCopy?: string
  }
};

export default () => {
  mediatorChannels.base.subscribe(
    "PICK_BETS_ONBOARDING_SEEN",
    (data: PickBetsOnboardingGTMType) => {
      pushToDataLayer({
        event: "siteClick",
        gaEventCategory: "Site Click",
        gaEventAction: "seen",
        gaEventLabel: get(data, "payload.onBoardingType", ""),
        module: "racecard",
        tag: undefined
      });
    }
  );

  mediatorChannels.base.subscribe(
    "PICK_BETS_ONBOARDING_CLICK_INFO_BUBBLE",
    () => {
      pushToDataLayer({
        event: "siteClick",
        gaEventCategory: "Site Click",
        gaEventAction: "select",
        gaEventLabel: "info bubble",
        module: "racecard",
        tag: undefined
      });
    }
  );

  mediatorChannels.base.subscribe(
    "PICK_BETS_ONBOARDING_CLICK_CTA",
    (data: PickBetsOnboardingGTMType) => {
      pushToDataLayer({
        event: "siteClick",
        gaEventCategory: "Site Click",
        gaEventAction: "select",
        gaEventLabel: get(data, "payload.buttonCopy", ""),
        module: "racecard",
        tag: undefined
      });
    }
  );

  mediatorChannels.base.subscribe(
    "PICK_BETS_ONBOARDING_CLOSE_MODAL",
    (data: PickBetsOnboardingGTMType) => {
      pushToDataLayer({
        event: "siteClick",
        gaEventCategory: "Site Click",
        gaEventAction: "close",
        gaEventLabel: get(data, "payload.buttonCopy", ""),
        module: "racecard",
        tag: undefined
      });
    }
  );
};
